import { SpinnerSC } from "pages/style/spinner/spinner-styled";

interface Props {
    height?: string;
}

export const Loading: React.FC<Props> = ({ height }) => {
    return (
        <SpinnerSC height={height}>
            <div className="spinner-border text-secondary" role="status"></div>
        </SpinnerSC>
    );

}
